<template>
  <div>
    <div id="map"></div>
  </div>
</template>

<script>
export default {
  name: 'KakaoMap',
  props: {
    centerPositions: [],
    parkingList: [],
  },

  data() {
    return {
      markers: [],
      positions: [],
      ckImg: null,
      imageSize: null,
      imageOption: null,
    };
  },

  watch: {
    parkingList() {
      this.initMap();
    },
  },

  mounted() {
    if (window.kakao && window.kakao.maps) {
      this.initMap();
    } else {
      const script = document.createElement('script');
      script.onload = () => kakao.maps.load(this.initMap);
      script.src = '//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=bb882e32593bf73248331975476ffa23';
      document.head.appendChild(script);
    }
  },

  methods: {
    // 파랑 마커
    mapMarker() {
      return require('../assets/images/map/map_marker_blue.png');
    },

    // 파랑 마커
    mapPcMarker() {
      return require('../assets/images/map/map_marker_blue.png');
    },

    // 빨강 마커
    mapMarkerRed() {
      return require('../assets/images/map/map_marker_red.png');
    },

    // 빨강 마커
    mapPcMarkerRed() {
      return require('../assets/images/map/map_marker_red.png');
    },

    // 주황 마커
    mapMarkerOrg() {
      return require('../assets/images/map/map_marker_org.png');
    },

    // 주황 마커
    mapPcMarkerOrg() {
      return require('../assets/images/map/map_marker_org.png');
    },

    initMap() {
      const container = document.getElementById('map');
      try {
        const options = {
          center: new kakao.maps.LatLng(this.centerPositions[0], this.centerPositions[1]),
          level: 5,
        };
        this.map = new kakao.maps.Map(container, options);

        this.displayMarker();
      } catch (ReferenceError) {
        return;
      }
    },

    displayMarker() {
      const parkingList = this.parkingList;

      const bounds = new kakao.maps.LatLngBounds();

      // 마커이미지의 크기입니다
      this.imageSize = new kakao.maps.Size(27, 44);
      this.imageOption = { offset: new kakao.maps.Point(12, 34) };

      for (let i = 0; i < parkingList.length; i++) {
        if (parkingList[i].LAT % 1 != 0 && !isNaN(parkingList[i].LAT)) {
          const position = new kakao.maps.LatLng(parkingList[i].LAT, parkingList[i].LNG);
          this.positions.push(position);

          const parkingCnt = ((parkingList[i].CELL_CNT - parkingList[i].PARK_COUNT) / parkingList[i].CELL_CNT) * 100;

          this.markers.push(
            new kakao.maps.Marker({
              map: this.map,
              position: position,
              clickable: true,
              image: new kakao.maps.MarkerImage(this.setMarkerImages(parkingCnt), this.imageSize, this.imageOption),
            }),
          );

          bounds.extend(position);
        }
      }

      this.$emit('kakaoMapMarker', this.markers, this.map, this.positions);

      this.map.setBounds(bounds);
    },

    setMarkerImages(parkingDivCd) {
      if (parkingDivCd > 80) {
        return this.mapMarkerRed();
      } else if (parkingDivCd > 60) {
        return this.mapMarkerOrg();
      } else {
        return this.mapMarker();
      }
    },
  },
};
</script>

<style scoped>
#map {
  width: 100%;
  height: 700px;
}
</style>
